import React, { createContext, useContext, useState } from 'react';

interface DialogContextType {
  isAnyDialogOpen: boolean;
  onDialogOpen: () => void;
  onDialogClose: () => void;
}

const DialogContext = createContext<DialogContextType>({
  isAnyDialogOpen: false,
  onDialogOpen: () => {},
  onDialogClose: () => {},
});

export const useDialog = () => useContext(DialogContext);

export const DialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [openDialogCount, setOpenDialogCount] = useState(0);

  const handleDialogOpen = () => {
    setOpenDialogCount(prev => prev + 1);
  };

  const handleDialogClose = () => {
    setOpenDialogCount(prev => Math.max(0, prev - 1));
  };

  return (
    <DialogContext.Provider
      value={{
        isAnyDialogOpen: openDialogCount > 0,
        onDialogOpen: handleDialogOpen,
        onDialogClose: handleDialogClose,
      }}
    >
      {children}
    </DialogContext.Provider>
  );
}; 